export const getHashParams = (url: string): URLSearchParams => {
  const hashIndex = url.indexOf('#');
  if (hashIndex === -1) return new URLSearchParams(); // No hash found

  const hashParams = url.substring(hashIndex + 1);
  return new URLSearchParams(hashParams); // Directly pass the hash string
};
